/* Dropmagic Asset | Version: 1.0.0 */
if (!customElements.get('dm-delivery-date')) {
  customElements.define('dm-delivery-date', class DMDeliveryDate extends HTMLElement {
    constructor() {
      super();

      // Get date configuration from dataset
      const dispatchedMinDate = parseInt(this.dataset.dispatchedMinDate, 10) || 0;
      const dispatchedMaxDate = parseInt(this.dataset.dispatchedMaxDate, 10) || 0;
      const deliveredMinDate = parseInt(this.dataset.deliveredMinDate, 10) || 0;
      const deliveredMaxDate = parseInt(this.dataset.deliveredMaxDate, 10) || 0;

      // Get DOM elements
      this.nowElement = this.querySelector('[data-dm-delivery-date-now]');
      this.dispatchedElement = this.querySelector('[data-dm-delivery-date-dispatched]');
      this.deliveredElement = this.querySelector('[data-dm-delivery-date-delivered]');

      if (!this.nowElement || !this.dispatchedElement || !this.deliveredElement) {
        console.error('[DM Delivery Date] Missing required DOM elements');
        return;
      }

      // Get locale from Shopify locale or default to en
      this.locale = window.Shopify?.locale ?? "en";

      // Calculate and update dates
      this.updateDates(dispatchedMinDate, dispatchedMaxDate, deliveredMinDate, deliveredMaxDate);
    }

    // Map 2-letter language codes to full locale codes for date formatting
    getFullLocaleFromCode(langCode) {
      const localeMap = {
        en: 'en-US',
        es: 'es-ES',
        fr: 'fr-FR',
        pt: 'pt-PT',
        de: 'de-DE',
        it: 'it-IT',
        nl: 'nl-NL',
        pl: 'pl-PL',
        ro: 'ro-RO',
        el: 'el-GR',
        cs: 'cs-CZ',
        hu: 'hu-HU',
        sv: 'sv-SE',
        da: 'da-DK',
        fi: 'fi-FI',
        no: 'no-NO',
        sk: 'sk-SK',
        bg: 'bg-BG',
        tr: 'tr-TR',
        id: 'id-ID',
        vi: 'vi-VN',
        sr: 'sr-RS',
        hr: 'hr-HR',
        bs: 'bs-BA',
        sl: 'sl-SI',
        lt: 'lt-LT',
        lv: 'lv-LV',
        et: 'et-EE',
        uk: 'uk-UA',
        mk: 'mk-MK',
        is: 'is-IS',
        ru: 'ru-RU',
        mt: 'mt-MT'
      };

      const fullLocale = localeMap[langCode] || 'en-US';
      
      if (!localeMap[langCode]) {
        console.warn('[DM Delivery Date] Unknown language code, using default:', langCode, '-> en-US');
      }

      return fullLocale;
    }

    // Format date range (same logic as TypeScript component)
    formatDateRange(minDays, maxDays) {
      const now = new Date();
      
      const startDate = new Date(now);
      startDate.setDate(now.getDate() + minDays);

      const endDate = new Date(now);
      endDate.setDate(now.getDate() + maxDays);

      const formatDate = (date) => {
        try {
          const day = date.getDate();
          const fullLocale = this.getFullLocaleFromCode(this.locale);
          const month = date.toLocaleDateString(fullLocale, { month: 'short' });
          return `${day} ${month}`;
        } catch (error) {
          console.error('[DM Delivery Date] Error formatting date:', error);
          return date.getDate() + ' ' + date.toLocaleDateString('en-US', { month: 'short' });
        }
      };

      const startFormatted = formatDate(startDate);
      const endFormatted = formatDate(endDate);

      // If same date, return single date, otherwise return range
      return (minDays === maxDays) ? startFormatted : `${startFormatted} - ${endFormatted}`;
    }

    // Update all date elements
    updateDates(dispatchedMinDate, dispatchedMaxDate, deliveredMinDate, deliveredMaxDate) {
      try {
        // Get formatted date ranges
        const todayFormatted = this.formatDateRange(0, 0);
        const dispatchedRange = this.formatDateRange(dispatchedMinDate, dispatchedMaxDate);
        const deliveredRange = this.formatDateRange(deliveredMinDate, deliveredMaxDate);

        // Update DOM elements
        this.nowElement.textContent = todayFormatted;
        this.dispatchedElement.textContent = dispatchedRange;
        this.deliveredElement.textContent = deliveredRange;
      } catch (error) {
        console.error('[DM Delivery Date] Error during date updates:', error);
      }
    }
  });
}